import { render, staticRenderFns } from "./GenitoriAssociate.vue?vue&type=template&id=58787d9d"
import script from "./GenitoriAssociate.vue?vue&type=script&lang=js"
export * from "./GenitoriAssociate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports